import { produce } from "immer";
import {
  ADD_FIELD,
  ADD_FIELD_FAILURE,
  ADD_FIELD_SUCCESS,
  //
  DELETE_FIELD,
  DELETE_FIELD_FAILURE,
  DELETE_FIELD_SUCCESS,
  //
  EDIT_FIELD,
  EDIT_FIELD_FAILURE,
  EDIT_FIELD_SUCCESS,
  //
  FETCH_FIELDS,
  FETCH_FIELDS_FAILURE,
  FETCH_FIELDS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_FIELD_ADD_MODAL,
  //
  UPDATE_FIELD_ORDER,
  UPDATE_FIELD_ORDER_SUCCESS,
  UPDATE_FIELD_ORDER_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingFields: false,
  team: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentField: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  fieldAddModal: {
    open: false,
    isEditing: false,
  },
  isUpdatingFieldOrder: false,
};

const FieldReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_FIELDS:
        draft.isFetchingFields = true;
        draft.team = [];
        break;
      case FETCH_FIELDS_SUCCESS:
        draft.isFetchingFields = false;
        draft.team = action.payload;
        break;
      case FETCH_FIELDS_FAILURE:
        draft.isFetchingFields = false;
        draft.team = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentField = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentField = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentField = {};
        break;
      // Add
      case ADD_FIELD:
        draft.isSubmitting = true;
        break;
      case ADD_FIELD_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_FIELD_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_FIELD:
        draft.isSubmitting = true;
        break;
      case EDIT_FIELD_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_FIELD_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_FIELD:
        draft.isDeleting = true;
        break;
      case DELETE_FIELD_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_FIELD_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_FIELD_ADD_MODAL:
        draft.fieldAddModal = action.payload;
        break;

      case UPDATE_FIELD_ORDER:
        draft.isUpdatingFieldOrder = true;
        break;
      case UPDATE_FIELD_ORDER_SUCCESS:
        draft.isUpdatingFieldOrder = false;
        break;
      case UPDATE_FIELD_ORDER_FAILURE:
        draft.isUpdatingFieldOrder = false;
        break;

      default:
        return state;
    }
  });

export default FieldReducer;
